<template>
  <details-grid
    :title="title"
    :header="header"
    :rows="rows"
    :max-length="width"
  />
</template>

<script>
import DetailsGrid from "@/components/DetailsGrid";
import { alignPrice, priceColumnWidth, toLocaleCurrency } from "@/utils/strings";

// Riepilogo di un sospeso (cassa SS) o di un acconto (cassa AC): stato,
// importi positivi e negativi, abbuono e residuo. I campi arrivano dal
// genitore con chiavi `${kind}_status`, `${kind}_pos`, `${kind}_neg`,
// `gross`, `rebate`, `total_gross`.
const TREASURY = { deferred: "SS", deposited: "AC" };

export default {
  components: { DetailsGrid },
  props: {
    kind: {
      type: String,
      required: true,
      validator: (v) => v in TREASURY,
    },
    header: String,
    title: String,
    fields: Array,
    data: Object,
  },
  computed: {
    details() {
      return this.data.entry_details.filter(
        (e) => e.treasury.code === TREASURY[this.kind]
      );
    },
    pos() {
      return this.sum(this.details.filter((e) => e.gross > 0));
    },
    neg() {
      return this.sum(this.details.filter((e) => e.gross < 0));
    },
    // Abbuono (cassa AB) registrato sul primo movimento negativo che lo ha.
    rebate() {
      for (const detail of this.details.filter((e) => parseFloat(e.gross) < 0)) {
        const found = detail.entry_details.find(
          (e) => e.treasury.code === "AB"
        );
        if (found) return found.gross;
      }
      return 0;
    },
    // Il residuo di un acconto ha il segno opposto a quello di un sospeso.
    total() {
      return this.kind === "deferred"
        ? this.sum(this.details)
        : -(this.pos + this.neg);
    },
    values() {
      return {
        [`${this.kind}_status`]: this.total === 0 ? "CHIUSO" : "APERTO",
        gross: toLocaleCurrency(this.data.gross),
        [`${this.kind}_pos`]: toLocaleCurrency(this.pos),
        [`${this.kind}_neg`]: toLocaleCurrency(-(this.neg + this.rebate)),
        rebate: toLocaleCurrency(this.rebate),
        total_gross: toLocaleCurrency(this.total),
      };
    },
    width() {
      return priceColumnWidth(Object.values(this.values));
    },
    rows() {
      return this.fields.map((field) => {
        const value = this.values[field.value];
        return field.value === `${this.kind}_status`
          ? { label: field.label, value }
          : { label: field.label, html: alignPrice(value, this.width) };
      });
    },
  },
  methods: {
    sum(details) {
      return parseFloat(
        details.reduce((acc, e) => acc + e.gross, 0).toFixed(2)
      );
    },
  },
};
</script>
